/* Instant colorway swap for linked sibling products.
   Prefetch on intent -> in-memory cache -> reuse VariantSelects.updateCombinedListingElements.
   Security: same-origin /products/ paths only; DOM comes exclusively from Shopify section renders. */
(function () {
  "use strict";
  var cache = new Map(); // url -> html text
  var MAX_CACHE = 20;

  function safeProductPath(href) {
    try {
      var u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return null;
      if (!/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?products\/[a-z0-9-]+\/?$/.test(u.pathname)) return null;
      return u.pathname;
    } catch (e) { return null; }
  }

  function getPicker() {
    return document.querySelector("variant-radios, variant-selects");
  }

  function sectionUrl(path, picker) {
    var sid = picker.dataset.originalSection || picker.dataset.section;
    return path + "?section_id=" + encodeURIComponent(sid);
  }

  function prefetch(url) {
    if (cache.has(url)) return;
    if (cache.size >= MAX_CACHE) cache.delete(cache.keys().next().value);
    cache.set(url, fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).catch(function () { cache.delete(url); }));
  }

  function selectedSizeValue(picker) {
    var checked = picker.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < checked.length; i++) {
      if (sizeKey(checked[i].value)) return checked[i].value;
    }
    return null;
  }

  // Catalog spells the same size several ways ("48\"x24\"", "48\"x24\"-BIG DESKS ONLY!!").
  // Normalize to digits+x so size survives swaps regardless of spelling.
  function sizeKey(v) {
    var m = String(v).toLowerCase().replace(/[^0-9x]/g, "").match(/^\d+x\d+/);
    return m ? m[0] : null;
  }

  function restoreSize(sizeValue) {
    var want = sizeKey(sizeValue);
    if (!want) return;
    var picker = getPicker();
    if (!picker) return;
    var inputs = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (sizeKey(inputs[i].value) === want && !inputs[i].disabled) {
        if (!inputs[i].checked) {
          inputs[i].checked = true;
          inputs[i].dispatchEvent(new Event("change", { bubbles: true }));
        }
        return;
      }
    }
  }

  function updateHeadLinks(path) {
    var href = window.location.origin + path;
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.href = href;
    var og = document.querySelector('meta[property="og:url"]');
    if (og) og.content = href;
  }

  function swap(anchor) {
    var path = safeProductPath(anchor.getAttribute("href"));
    var picker = getPicker();
    if (!path || !picker || typeof picker.updateCombinedListingElements !== "function") return false;
    var url = sectionUrl(path, picker);
    var keepSize = selectedSizeValue(picker);
    var group = anchor.closest(".linked-products");
    if (group) group.classList.add("ga-swapping");
    if (!cache.has(url)) prefetch(url);
    cache.get(url).then(function (text) {
      if (!text) { window.location.href = path; return; }
      var html = new DOMParser().parseFromString(text, "text/html");
      picker.dataset.url = path;
      // Shift's own flow sets the current variant from the fetched HTML BEFORE the
      // combined-listing swap; skipping it leaves currentVariant undefined and the
      // swap's tail disables the buy button as "Unavailable".
      if (typeof picker.setCurrentVariantAfterFetch === "function") {
        try { picker.setCurrentVariantAfterFetch(html); } catch (e) {}
      }
      picker.updateCombinedListingElements(html);
      window.history.pushState({ gaLinkedSwap: true }, "", path);
      updateHeadLinks(path);
      restoreSize(keepSize);
      // keep the tab title in step with the swapped product (section HTML carries no <title>)
      var newH1 = document.querySelector(".product__title h1, h1.product__title, .product__info-container h1, .product__info-wrapper h1");
      if (newH1) {
        var suffix = document.title.match(/\s[–—|-]\s[^–—|-]+$/);
        document.title = newH1.textContent.trim() + (suffix ? suffix[0] : "");
      }
    }).catch(function () {
      window.location.href = path;
    }).finally(function () {
      if (group) group.classList.remove("ga-swapping");
    });
    return true;
  }

  function onIntent(e) {
    var a = e.target.closest && e.target.closest(".linked-products__option[href]");
    if (!a) return;
    var path = safeProductPath(a.getAttribute("href"));
    var picker = getPicker();
    if (path && picker) prefetch(sectionUrl(path, picker));
  }

  document.addEventListener("mouseover", onIntent, { passive: true });
  document.addEventListener("focusin", onIntent);
  document.addEventListener("touchstart", onIntent, { passive: true });

  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest(".linked-products__option[href]");
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; // let new-tab etc. through
    if (a.classList.contains("is-soldout")) return; // GA: sold-out colour -> full load so the AMP "Notify me" button initialises
    if (swap(a)) e.preventDefault();
  });

  window.addEventListener("popstate", function (e) {
    if (e.state && e.state.gaLinkedSwap) window.location.reload();
  });

  /* Mobile: horizontal swipe on the product media cycles linked colorways */
  var touchX = null, touchY = null;
  document.addEventListener("touchstart", function (e) {
    var media = e.target.closest && e.target.closest(".product__media-wrapper");
    if (!media || !document.querySelector(".linked-products__option[href]")) { touchX = null; return; }
    touchX = e.touches[0].clientX; touchY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener("touchend", function (e) {
    if (touchX === null) return;
    var dx = e.changedTouches[0].clientX - touchX;
    var dy = e.changedTouches[0].clientY - touchY;
    touchX = null;
    if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var options = Array.prototype.slice.call(document.querySelectorAll(".linked-products__option"));
    if (options.length < 2) return;
    var idx = options.findIndex(function (o) { return o.classList.contains("is-active"); });
    var next = dx < 0 ? idx + 1 : idx - 1;
    if (next < 0) next = options.length - 1;
    if (next >= options.length) next = 0;
    var target = options[next];
    if (target && target.hasAttribute("href")) swap(target);
  }, { passive: true });
})();
